export default "__VITE_PUBLIC_ASSET__08925400__"